import { registerPropertyManagerSection } from '@/core';
import RevolveCutPropertySection from '@/components/editor/property-manager/revolve-cut/RevolveCutPropertySection.vue';

registerPropertyManagerSection({
  id: 'revolve-cut',
  title: '旋转切除',
  order: 32,
  component: RevolveCutPropertySection,
  actions: {
    confirm: true,
    cancel: true,
  },
  resolveConfirmDisabled: (context) => context.revolveCutState?.canSubmit === false,
  isApplicable: (context) => {
    if (context.activeCommand === 'revolve-cut') {
      return true;
    }
    return Boolean(context.revolveCutActive);
  },
  onConfirm: (context) => {
    context.onConfirm?.();
  },
  onCancel: (context) => {
    context.cancelRevolveCut?.();
  },
});
